import React from 'react';
import "./ButtonListDesktop.scss";
import {Col, Row} from "antd";
import {LazyImage} from "../../../Components";
import {detectEnglishLang} from "../../../Services";
import {useHistory} from "react-router";

const style = {
    background: '#0092ff'
};

function ButtonListDesktop ({item,LinkDispatcher}){

    const history = useHistory()

    return(
        <Row gutter={[4,4]} justify="center"  className="component-row">
        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24}} >
            <div className="digi_badg_actions">
                {item.items.map(itemz => {
                    return (
                        <div key={itemz.uid} className="digi_badg_actions_item"
                             onClick={() => {
                                 // let res = itemz.link_to_uid.replace("online-store-categories","shop")
                                 // history.push(res)
                                  LinkDispatcher(itemz.link_to, itemz)
                             }}>
                            <img src={itemz.image_desktop} alt="" style={{width: 120}}/>
                            <span style={{fontSize:15}} className={detectEnglishLang(itemz.title) ? "eng-title" : "per-title"}>{itemz.title}</span>
                        </div>
                    )
                })}
            </div>
        </Col>
        </Row>
    )
}

export default ButtonListDesktop;
